export const partnersArray = () => [
  {
    id: "partnerId",
    name: "partnerId",
    label: "Partner",
  },
];